<!-- 设置规格 -->
<template>
  <div>
    <el-dialog
      width="952px"
      title="设置参数(尺寸默认单位mm，重量默认单位kg)"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <div class="flex flex-y-center m-b-10">
          <div>参数示图：</div>
          <e-upload-image :list.sync="selfCanShuTuPian" :limit="1" size="330px" isDelete />
        </div>
        <div class="texture-main">
          <div>规格参数：</div>
          <div class="texture-item" v-for="(itemSt, indexSt) in selfList" :key="indexSt">
            <div>
              <el-select v-model="itemSt.val" size="mini" :disabled="disabled" clearable>
                <el-option
                  v-for="(itemNd, indexNd) in allList"
                  class="flex flex-x-between"
                  :key="indexNd"
                  :label="itemNd.key"
                  :value="itemNd.val"
                />
              </el-select>
            </div>
            <div v-if="indexSt < selfList.length - 1" class="p-x-5">*</div>
          </div>
        </div>
        <div class="flex flex-y-center">
          <div class="m-t-5" style="align-self: flex-start">附加参数：</div>
          <div class="flex-1">
            <vxe-grid
              ref="refTableProcess"
              :height="256"
              :header-cell-class-name="headerCellClassName"
              :toolbar-config="tableConfig.toolbarConfig"
              :edit-config="tableConfig.editConfig"
              :row-config="tableConfig.rowConfig"
              :mouse-config="tableConfig.mouseConfig"
              :keyboard-config="tableConfig.keyboardConfig"
              :columns="tableColumn"
              :data="selfFuJiaCanShuList"
            >
              <!-- 排序 -->
              <template #default_move>
                <span v-if="!disabled" class="iconfont icon-drag cursor-move" />
              </template>

              <!-- 附加参数 -->
              <template #edit_name="{ row }">
                <el-input v-model="row.name" size="mini" clearable />
              </template>

              <!-- 操作 -->
              <template #default_do="{ rowIndex }">
                <el-link v-if="!disabled" type="success" @click="rowAdd"> 增行 </el-link>
                <el-link
                  v-if="!disabled && selfFuJiaCanShuList.length > 1"
                  type="danger"
                  @click="rowDelete(rowIndex)"
                >
                  删行
                </el-link>
              </template>

              <!-- 数据为空 -->
              <template #empty>
                <div class="flex flex-center">
                  <span class="f-s-14 c-gray-light">暂无数据</span>
                  <el-link v-if="!disabled" class="m-l-10" type="success" @click="rowAdd">
                    增行
                  </el-link>
                </div>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
export default {
  components: {},
  props: {
    show: {
      type: Boolean,
      required: true
    },
    gui_ge_list: {
      type: Array,
      required: true
    },
    can_shu_tu_pian: {
      type: Array,
      required: true
    },
    fu_jia_can_shu_list: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selfShow: false,
      allList: this.$constant.shangPinMuBanGuiGeList,
      selfList: [],
      selfCanShuTuPian: [],
      selfFuJiaCanShuList: [],
      tableColumn: [
        {
          fixed: 'left',
          title: '排序',
          width: 120,
          slots: { default: 'default_move' }
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '附加参数',
          field: 'name',
          slots: { edit: 'edit_name' },
          editRender: { autofocus: '.el-input__inner' }
        },
        {
          title: '操作',
          width: 120,
          slots: { default: 'default_do' }
        }
      ]
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.initSelfList()
    if (!this.selfFuJiaCanShuList.length) this.rowAdd() // 数据为空，默认补一行
    if (!this.disabled) this.rowDrop()
  },
  methods: {
    // 初始化列表数据
    initSelfList() {
      for (let i = 0; i < 5; i++) {
        let result = {
          val: this.gui_ge_list[i] || ''
        }
        this.selfList.push(result)
      }
      this.selfCanShuTuPian = this.$util.deepCopy(this.can_shu_tu_pian)
      this.selfFuJiaCanShuList = this.$util.deepCopy(this.fu_jia_can_shu_list)
    },
    // 行拖拽
    rowDrop() {
      this.$nextTick(() => {
        let $table = this.$refs.refTableProcess
        let $sortContent = $table.$el.querySelector('.body--wrapper>.vxe-table--body tbody')
        this.sortable = Sortable.create($sortContent, {
          handle: '.icon-drag',
          animation: 150,
          onEnd: ({ newIndex, oldIndex }) => {
            let data = this.$util.deepCopy(this.selfFuJiaCanShuList)
            let oldItem = this.$util.deepCopy(data[oldIndex])
            // 上移
            if (newIndex < oldIndex) {
              if (newIndex === 0) {
                data.splice(oldIndex, 1)
                data.unshift(oldItem) // 顶部
              } else {
                data.splice(oldIndex, 1)
                data.splice(newIndex, 0, oldItem)
              }
            }
            // 下移
            if (newIndex > oldIndex) {
              if (newIndex === data.length - 1) {
                data.push(oldItem) // 底部
                data.splice(oldIndex, 1)
              } else {
                data.splice(newIndex + 1, 0, oldItem)
                data.splice(oldIndex, 1)
              }
            }
            this.selfFuJiaCanShuList = this.$util.deepCopy(data)
          }
        })
      })
    },
    // 表格单元格样式设置
    headerCellClassName({ column }) {
      if (column.slots && column.slots.edit) return 'edit'
      return null
    },
    // 行-增行
    rowAdd() {
      let result = {
        is_show: true,
        is_edit: false,
        is_set: false,
        name: '',
        zi_duan_ku_id: '',
        lei_xing_str: '输入框(文字)',
        lei_xing_id: 1,
        value: ''
      }
      this.selfFuJiaCanShuList.push(result)
      if (this.$refs.refTableProcess) this.$refs.refTableProcess.clearCurrentRow()
    },
    // 行-删行
    rowDelete(index) {
      this.selfFuJiaCanShuList.splice(index, 1)
      this.$refs.refTableProcess.clearCurrentRow()
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      let result = []
      this.selfList.forEach((item) => {
        if (item.val) result.push(item.val)
      })
      this.$emit('update:gui_ge_list', result)
      this.$emit('update:can_shu_tu_pian', this.selfCanShuTuPian)
      this.$emit(
        'update:fu_jia_can_shu_list',
        this.selfFuJiaCanShuList.filter((item) => item.name)
      )
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .texture-main {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .texture-item {
      display: flex;
      align-items: center;
    }
  }
}
</style>
